// قواعد الطباعة على ورق A4 — تُضمّن في نهاية CSS التقرير (الخادم يطبع نفس الصفحة بمتصفح حقيقي).
export const inlineCss = (T) => `
.qr { display: flex; align-items: center; gap: 8px; margin-top: 10px; justify-content: center; }
.qr-img { height: 62px; width: 62px; }
.qr-text { text-align: start; }
.qr-title { font-size: 9px; font-weight: 700; color: ${T.primary}; }
.qr-hash { font-family: monospace; font-size: 9px; color: #111; }
.qr-url { font-size: 8px; color: ${T.muted}; }
.sub { font-size: 9px; color: ${T.muted}; }
.b { font-weight: 700; }
.neg { color: ${T.negInline}; }
.pos { color: ${T.posInline}; }
.danger { color: ${T.danger}; }
.positive { color: ${T.positive}; }
.badge { display: inline-block; border-radius: 999px; padding: 1px 6px; margin: 1px; font-size: 9px; font-weight: 700; }
`;

export const printCss = (compact) => `
@page { size: A4 landscape; margin: 8mm; }
.pdf-bar { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
.pdf-bar button { font-family: inherit; font-size: 15px; font-weight: 800; border: 0; cursor: pointer;
  border-radius: 10px; padding: 12px 20px; color: #fff; line-height: 1.2; }
@media screen and (min-width: 821px) {
  .print-buttons, .pdf-bar { display: inline-flex; vertical-align: top; margin: 0 10px 16px 0; }
}
body.mobile-report { position: fixed; inset: 0; overflow: hidden; margin: 0; padding: 0;
  overscroll-behavior: none; touch-action: none; visibility: hidden; }
#rpt-viewport { position: fixed; top: 0; left: 0; right: 0; bottom: 112px; overflow: hidden;
  background: #fff; touch-action: none; z-index: 1; }
body.embedded .pdf-bar { display: none !important; }
body.embedded.mobile-report #rpt-viewport { bottom: 0 !important; }
#rpt-scale { position: absolute; top: 0; left: 0; width: 1100px; transform-origin: 0 0;
  padding: 18px; box-sizing: border-box; }
body.mobile-report .pdf-bar,
body.mobile-report .print-buttons { position: fixed; left: 0; right: 0; width: 100%; margin: 0;
  padding: 6px 8px; gap: 8px; display: flex; background: rgba(238, 241, 246, 0.97); z-index: 60; }
body.mobile-report .pdf-bar { bottom: 0; }
body.mobile-report .print-buttons { bottom: 0; padding-bottom: 8px; }
body.mobile-report .pdf-bar button,
body.mobile-report .print-buttons button { flex: 1 1 44%; min-width: 0; white-space: nowrap;
  font-size: 15px; font-weight: 900; padding: 11px 6px; border-radius: 12px; line-height: 1.15; }
.pdf-bar button, .print-buttons button {
  touch-action: manipulation; -webkit-tap-highlight-color: transparent;
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.3), 0 12px 22px rgba(0, 0, 0, 0.28),
    inset 0 2px 0 rgba(255, 255, 255, 0.55), inset 0 -4px 10px rgba(0, 0, 0, 0.22);
  transition: transform 0.12s ease, box-shadow 0.12s ease; text-shadow: 0 2px 3px rgba(0, 0, 0, 0.4);
}
.btn-pdf { background: linear-gradient(180deg, #6366f1, #3730a3) !important; }
.btn-print { background: linear-gradient(180deg, #3b82f6, #2563eb) !important;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px; }
.btn-pdfshare { background: linear-gradient(180deg, #22c55e, #15803d) !important; }
.btn-copy { background: linear-gradient(180deg, #f59e0b, #b45309) !important; }
.btn-close { background: linear-gradient(180deg, #f43f5e, #9f1239) !important; }
.pdf-bar button:active, .print-buttons button:active { transform: translateY(4px);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.3), inset 0 2px 0 rgba(255, 255, 255, 0.3); }
body.mobile-report .pdf-bar button, body.mobile-report .print-buttons button {
  box-shadow: 0 0.8vw 0 rgba(0, 0, 0, 0.3), 0 1.5vw 2.4vw rgba(0, 0, 0, 0.26),
    inset 0 0.3vw 0 rgba(255, 255, 255, 0.5), inset 0 -0.5vw 1vw rgba(0, 0, 0, 0.2);
}
@media print {
  body { padding: 0; }
  .print-buttons, .share-bar, .pdf-bar { display: none !important; }
  .cards, .explain, .warn, .signature, thead { page-break-inside: avoid; }
  tr { page-break-inside: avoid; }
  ${compact ? "" : ".header { page-break-after: avoid; }"}
}
`;
